<template>
  <login />
</template>
<script>
import LoginComponent from './LoginComponent.vue';
import LoginState from './LoginState';

const loginService = new LoginState();

export default {
  components: { login: LoginComponent },
  provide: () => ({ loginService }),
  mounted() {
    loginService.setSignInSuccessListener(this.onLoginSuccess);
    loginService.checkForSSORedirect(this.$route.params.ssoProvider);
  },
  methods: {
    async onLoginSuccess() {
      await this.$store
        .dispatch('GetUserInfo')
        .then(async () => {
          await this.$store.dispatch('GenerateRoutes');
        })
        .catch(() => {
          if (!this.$store.getters.user) {
            window.location.href = `${process.env.VUE_APP_BASE_URL}#/401`;
          }
        });
      const path = this.$route.query.redirect || '/';
      console.log(`router.push ${path}`);
      await this.$router.push(path);
    },
  },
};
</script>
